import * as PropTypes                  from 'prop-types';
import {
    compose,
    withProps,
    withState,
    branch,
    renderNothing,
    getContext,
    lifecycle
}                                      from 'recompose';
import { connect }                     from 'react-redux';
import { withRouter }                  from 'react-router';
import MessagesInput                   from './MessagesInput';
import {
    MessagesInputType,
    MessagesInputContainerProps
}                                      from './MessagesInputTypes';
import { selectCustomField }           from '../CustomFields/CustomFieldsActions';
import { ViewContextTypes }            from '../MessageTemplatesList/MessageTemplatesListTypes';

const CHARACTER_LIMIT = 160;
const TEMPLATE_ITEMS_PER_PAGE = 1;

const isLoading = ({ loading }) => loading;

const sendInputMessage = (conversationId, value, sendMessage, setValue, activeLanguage, recipient) => {
    if (value.length <= CHARACTER_LIMIT && value.trim().length > 0) {
        sendMessage(conversationId, value, activeLanguage, recipient);
        setValue('');
    }
};

const mapDispatchers = (dispatch) => ({
    resetSelectedCustomField() {
        dispatch(selectCustomField(null, null));
    }
});

const mapStateToProps = state => ({
    activeLanguage: state.languageStore.activeLanguage
});

// TODO: proper reducer / actions after adding state properties?
const MessagesInputContainer = compose(
    connect(mapStateToProps, mapDispatchers),
    withRouter,
    withState('value', 'setValue', ''),
    withState('inputView', 'setInputView', ViewContextTypes.DEFAULT),
    withState('templatesInitialized', 'initializeTemplates', false),
    getContext({
        isOnCallList: PropTypes.bool.isRequired,
    }),
    withProps(({ setValue, sendMessage, conversationId, value, setInputView, resetSelectedCustomField, profanityMessage, activeLanguage, recipient }: MessagesInputContainerProps) => ({
        characterLimit: CHARACTER_LIMIT,
        itemsPerPage: TEMPLATE_ITEMS_PER_PAGE,
        handleChange: (event: React.SyntheticEvent<MessagesInputType>) => {
            setValue(event.currentTarget.value);
        },
        setDefault: (text: string) => {
            setValue(text);
        },
        handleSendMessage: () => sendInputMessage(conversationId, value, sendMessage, setValue, activeLanguage, recipient),
        // Send on enter key press on desktop
        handleKeyDown: (event) => {
            const condition = (
                (event as KeyboardEvent).key === 'Enter' &&
                !(event as any).nativeEvent.shiftKey &&
                window.innerWidth > 640 &&
                value.trim() !== profanityMessage
            );

            if (condition) {
                sendInputMessage(conversationId, value, sendMessage, setValue, activeLanguage, recipient);
                event.preventDefault();
                event.stopPropagation();
            } else {
                setValue(value.replace(/^\n|\n$/g, ''));
            }
        },
        handleChangeInputView({ target }) {
            resetSelectedCustomField();
            setInputView(target.value);
        },
    })),
    lifecycle<MessagesInputContainerProps, {}>({
        componentDidMount() {
            if (this.props.recipient.activity_type === '0') {
                this.props.setInputView(ViewContextTypes.MESSAGES_INPUT);
            }
        }
    }),
    branch(isLoading, renderNothing)
);

export default MessagesInputContainer(MessagesInput) as React.ComponentClass<MessagesInputContainerProps>;



// WEBPACK FOOTER //
// ./src/sections/MessagesInput/index.ts